import { render } from "./ChainWrapper.vue?vue&type=template&id=473720f2&scoped=true"
import script from "./ChainWrapper.vue?vue&type=script&lang=js"
export * from "./ChainWrapper.vue?vue&type=script&lang=js"

import "./ChainWrapper.vue?vue&type=style&index=0&id=473720f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473720f2"]])

export default __exports__